import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Validate from 'validate.js';
import { Cloudinary } from 'api/api-cloudinary';
import { buildImagePath } from 'config/paths';
import { FormattedMessage, injectIntl } from 'react-intl';
import { getCloudinaryTextData } from './data/cloudinary-data';

class AvatarUploadClass extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      photoError: '',
      widget: null,
      borderColor: 'valid-border',
      isValid: false,
      avatarImg: undefined
    };

    this.setImgState = this.setImgState.bind(this);
    this.setErrorState = this.setErrorState.bind(this);
    this.resetInput = this.resetInput.bind(this);
    this.isValid = this.isValid.bind(this);
    this.renderCloudinaryWidget = this.renderCloudinaryWidget.bind(this);
    this.onCloudinaryProfilePicUpload = this.onCloudinaryProfilePicUpload.bind(this);
    this.getValue = this.getValue.bind(this);
    this.renderHorizontalView = this.renderHorizontalView.bind(this);
    this.onCloudinaryCreateApiCb = this.onCloudinaryCreateApiCb.bind(this);
  }

  componentWillMount () {
    const { defaultAvatar } = this.props;
    if (defaultAvatar) {
      Cloudinary.create(defaultAvatar, this.onCloudinaryCreateApiCb);
    }
  }

  componentDidMount () {
    const locale = this.props.intl.locale;
    const profilePhotoPresets = {
      upload_preset: 'e6m9x7iz',
      show_powered_by: false,
      multiple: false,
      cropping: 'server',
      cropping_aspect_ratio: 1.0000001,
      mode: 'crop',
      gravity: 'custom',
      client_allowed_formats: ['jpg', 'jpeg', 'png'],
      sources: ['local'],
      theme: 'white',
      max_file_size: 8000000,
      max_image_width: 1000,
      max_image_height: 1000,
      showSkipCropButton: false,
      language: locale,
      text: {
        [locale]: getCloudinaryTextData(this.props.intl)
      }
    };
    let cloudinaryWidet;
    const uploadCb = (error, result) => {
      this.onCloudinaryProfilePicUpload(error, result);
    }
    if (typeof cloudinary !== 'undefined') {
      cloudinary.setCloudName('peerspace-inc');
      cloudinaryWidet = cloudinary.createUploadWidget(profilePhotoPresets, uploadCb);
    } else {
      window.cloudinary.setCloudName('peerspace-inc');
      cloudinaryWidet = window.cloudinary.createUploadWidget(profilePhotoPresets, uploadCb);
    }

    return this.setState({ widget: cloudinaryWidet });
  }

  onCloudinaryProfilePicUpload (err, result) {
    if (err) {
      this.setErrorState(this.props.intl.formatMessage({ id: 'shared_components.avatar_upload.error_message', defaultMessage: 'Please try uploading your image again.' }));
    } else if ('success' === result.event) {
      const imgInfo = (result || {}).info || {};
      const newProfileURL = imgInfo.secure_url;
      const croppedProfileURL = newProfileURL.replace('upload/', 'upload/c_crop,g_custom/');
      const user = {};
      user.avatar_url = croppedProfileURL;
      this.props.actionFn(user, function fireOnCallback (...args) {
        this.props.actionCb(
          croppedProfileURL,
          this.setImgState,
          this.setErrorState,
          ...args);
      }.bind(this));
    }
  }

  // Creating images from api call instead of Cloudinary widget
  // The api uses an older code of cloudinary therefore the callback is different
  onCloudinaryCreateApiCb (err, result) {
    if (err) {
      this.setErrorState(this.props.intl.formatMessage({ id: 'shared_components.avatar_upload.error_message', defaultMessage: 'Please try uploading your image again.' }));
    } else {
      const newProfileURL = result.length ? result[0].secure_url : result.secure_url;
      const croppedProfileURL = newProfileURL.replace('upload/', 'upload/c_crop,g_custom/');
      const user = {};
      user.avatar_url = croppedProfileURL;
      this.props.actionFn(user, function fireOnCallback (...args) {
        this.props.actionCb(
          croppedProfileURL,
          this.setImgState,
          this.setErrorState,
          ...args);
      }.bind(this));
    }
  }

  setImgState (img) {
    this.setState({
      avatarImg: img,
      isValid: true,
      borderColor: 'valid-border',
      photoError: ''
    });
  }

  setErrorState (errorMsg) {
    this.setState({
      photoError: errorMsg,
      isValid: false,
      borderColor: 'error-border'
    });
  }

  resetInput () {
    // resets state to initial state
    const inputObj = {};
    inputObj.photoError = '';
    inputObj.widget = null;
    inputObj.borderColor = 'valid-border';
    inputObj.avatarImg = null;
    this.setState(inputObj);
  }

  isValid () {
    let errorFree = true;
    const node = ReactDOM.findDOMNode(this);
    const input = node.getElementsByTagName('input')[0];
    const constraints = {
      presence: {
        message: <FormattedMessage id="shared_components.avatar_upload.please_upload" defaultMessage="Please upload a profile photo." />
      }
    };
    const isError = Validate.single(input.value, constraints);
    if (isError) {
      this.setErrorState(isError[0]);
      errorFree = false;
    }
    return errorFree;
  }

  getValue () {
    const { imageValue } = this.refs;
    return imageValue.value;
  }

  renderCloudinaryWidget (event) {
    event.preventDefault();
    this.state.widget.open();
  }

  renderHorizontalView () {
    const { showRequired = true } = this.props;
    const avatarPlaceholder = buildImagePath('default-avatar.svg?v=rb');
    return (
      <div className="col-xs-12 no-gutter">
        <div className={`avatar-upload ${this.props.bgColor}`}>
          <div className="container-fluid">
            {
              this.props.infoText &&
              <p className="text-center text-gray-dark upload-info-text">{this.props.infoText}</p>
            }
            <div className="row">
              <div className="flex middle">

                <div onClick={this.renderCloudinaryWidget} className={`text-center upload-photo-icon ${this.state.borderColor}`}>
                  <img src={this.state.avatarImg || this.props.avatarUrl || avatarPlaceholder} alt="upload avatar img" />
                </div>

                <div>
                  <button data-testing-id="horizontal-avatar-upload" tabIndex="1" onClick={this.renderCloudinaryWidget} className={`btn add-photo-btn ${this.props.buttonClass}`}>
                    { this.state.avatarImg ? this.props.intl.formatMessage({ id: 'shared_components.avatar_upload.update_photo', defaultMessage: 'Update photo' }) : this.props.buttonText }
                    {
                      showRequired ?
                        <span className="required">*</span> : null
                    }
                  </button>
                  <input ref="imageValue" type="hidden" value={this.state.avatarImg || this.props.avatarUrl} />
                </div>

              </div>
            </div>
            <div className="photo-error text-danger row">{this.state.photoError}</div>
          </div>
        </div>
      </div>
    );
  }

  render () {
    const { showRequired = true } = this.props;
    const avatarPlaceholder = buildImagePath('default-avatar.svg?v=rb');

    if (this.props.horizontalView) {
      // for the signup form refactor
      // dont want it to affect other views
      return this.renderHorizontalView();
    }

    return (
      <div className="col-xs-12">
        <div className={`upload-avatar-container avatar-upload ${this.props.bgColor} margin-lg-bottom`}>
          {
            showRequired ?
              <span className="required">*</span> : null
          }
          <div className="container-fluid">
            <p className="text-center text-gray-dark upload-info-text">{this.props.infoText}</p>
            <div className="row">
              <div className="row-height">
                <div className="col-xs-4 col-height col-middle">
                  <div onClick={this.renderCloudinaryWidget} className={`text-center upload-photo-icon ${this.state.borderColor}`}>
                    <img src={this.state.avatarImg || this.props.avatarUrl || avatarPlaceholder} alt="upload avatar img" />
                  </div>
                </div>
                <div className="col-xs-7 col-height col-middle">
                  <button data-testing-id="avatar-upload" tabIndex="1" onClick={this.renderCloudinaryWidget} className={`btn classic ${this.props.buttonClass}`}>
                    { this.props.buttonText }
                  </button>
                  <input ref="imageValue" type="hidden" value={this.state.avatarImg || this.props.avatarUrl} />
                </div>
              </div>
            </div>
            <div className="photo-error text-danger text-center">{this.state.photoError}</div>
          </div>
        </div>
      </div>
    );
  }
}

AvatarUploadClass.propTypes = {
  actionFn: PropTypes.func.isRequired,
  actionCb: PropTypes.func.isRequired,
  bgColor: PropTypes.string,
  infoText: PropTypes.string,
  showRequired: PropTypes.bool,
  buttonText: PropTypes.string,
  buttonClass: PropTypes.string,
  avatarUrl: PropTypes.string,
  horizontalView: PropTypes.bool,
  intl: PropTypes.object
};

AvatarUploadClass.defaultProps = {
  buttonText: <FormattedMessage id='shared_components.avatar_upload.add_photo' defaultMessage='Add a profile photo' />,
  buttonClass: 'btn-default btn-outlined-light'
};

export const AvatarUpload = injectIntl(AvatarUploadClass, { withRef: true, forwardRef: true });
